import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import logo from '../images/logo_oficial2018.png';
import Form from './Form';
import { Loading } from './Loading';
import Actividades from './Actividades';
import TranslateIcon from '@material-ui/icons/Translate';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  imgContainer: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2)
  },
  img: {
    width: '50VW',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    height: 'auto',
    objectFit: 'contain'
  },
  toolbar: {
    paddingRight: 24 // keep right padding when drawer closed
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  title: {
    flexGrow: 1,
    marginLeft: 12,
    marginRight: 36
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    minHeight: '100vh',
    overflow: 'auto',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(),
      paddingRight: theme.spacing()
    }
  },
  chartContainer: {
    marginLeft: -22
  },
  tableContainer: {
    height: 320
  },
  h5: {
    marginBottom: theme.spacing(2)
  },
  select: {
    color: 'inherit'
  },
  selectIcon: {
    color: 'inherit'
  },
  selectValueIcon: { fontSize: 14, paddingLeft: 4, paddingRight: 4 },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
});

const idiomas = [
  { value: 'es', label: 'Español' },
  { value: 'en', label: 'English' },
  { value: 'pt', label: 'Português' }
];

class Dashboard extends React.Component {
  state = { language: 'es' };

  render() {
    const { classes, t, i18n } = this.props;
    console.log('current language: ', i18n.language);

    const setLanguage = value => {
      this.setState({ language: value });
    };

    const handleChange = event => {
      setLanguage(event.target.value);
      console.log('current language: ', i18n.language);
      i18n.changeLanguage(event.target.value);
    };

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="absolute" className={classNames(classes.appBar)}>
          <Toolbar
            disableGutters={!this.state.open}
            className={classes.toolbar}
          >
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              className={classes.title}
            >
              REPSE - REDIEX {t("main.header")}
            </Typography>
            <div className={classes.sectionDesktop}>
              <FormControl>
                <Select
                  value={this.state.language}
                  onChange={handleChange}
                  disableUnderline
                  classes={{ icon: classes.selectIcon }}
                  style={{ color: 'inherit' }}
                  renderValue={value => (
                    <>
                      <TranslateIcon className={classes.selectValueIcon} />
                      {idiomas.find(item => item.value === value).label}
                    </>
                  )}
                >
                  {idiomas.map(item => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className={classes.sectionMobile} />
          </Toolbar>
          <Loading />
        </AppBar>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <div className={classes.imgContainer}>
            <img src={logo} alt="" className={classes.img} />
          </div>
          <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE || ''}>
            <Switch>
              <Route exact path="/" component={Form} />
              <Route path="/:dataset" component={Actividades} />
            </Switch>
          </BrowserRouter>
        </main>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles)(Dashboard));
